<h3 mat-dialog-title>Debugging Results</h3>
<mat-dialog-content>
    <pre [innerHTML]="debuggingService.alertMessage | prettyJson:[true, 2]"></pre>
</mat-dialog-content>
